export default __webpack_public_path__ + "static/media/en.6c7c229f.png";